import { useEffect } from 'react'
import { useQuery } from '@apollo/client'
import {
  MISSING_FREE_ANSWER_SUBMITS,
  MissingFreeAnswerSubmitsDataType
} from 'graphql/freeAnswer/queries'
import popupError from 'globals/popupError'
import { useTranslation } from 'react-i18next'

const MissingFreeAnswerSubmits: React.FC = () => {
  const { t } = useTranslation()
  const { data } = useQuery<MissingFreeAnswerSubmitsDataType>(
    MISSING_FREE_ANSWER_SUBMITS
  )

  useEffect(() => {
    if (data?.missingFreeAnswerSubmits && data?.missingFreeAnswerSubmits.length > 0)
      popupError(
        t('free-answers.missing-submits', {
          addresses: data?.missingFreeAnswerSubmits.map((submit) => submit.addressName).join(', ')
        }),
        0
      )
  }, [data])

  return <></>
}

export default MissingFreeAnswerSubmits
